import { render, staticRenderFns } from "./HJ0070.vue?vue&type=template&id=072e271e&scoped=true&"
import script from "./HJ0070.vue?vue&type=script&lang=js&"
export * from "./HJ0070.vue?vue&type=script&lang=js&"
import style0 from "./HJ0070.vue?vue&type=style&index=0&id=072e271e&prod&lang=less&scoped=true&"
import style1 from "./HJ0070.vue?vue&type=style&index=1&id=072e271e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072e271e",
  null
  
)

export default component.exports